import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../misc';
import includes from 'lodash.includes';

import DownloadDropdown from '../misc/DownloadDropdown';

import { ORIGINAL } from '../../utils/variables';

class AccountPhotoDownload extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { eventSgId, availableZips } = this.props;
    const originalsAreAvailable = includes(availableZips, ORIGINAL);

    return (
      <div className="col-xs-16 col-sm-6">
        <div className="account-photo-download-container">
          <div className="account-photo-download-body">
            <div className="account-photo-download-icon" />
            {originalsAreAvailable && (
              <h2>
                <FormattedMessageWrappedInSpan
                  id="accountPhotoDownload.originalsAreAvailable.title"
                  defaultMessage="All your photos are now available"
                />
              </h2>
            )}
            {!originalsAreAvailable && (
              <Fragment>
                <FormattedMessageWrappedInSpan
                  id="accountPhotoDownload.default.title"
                  defaultMessage="All your photos in social media resolution"
                />
                <br />
                <FormattedMessageWrappedInSpan
                  id="accountPhotoDownload.default.highResHint"
                  defaultMessage="(Photos in high resolution are coming soon)"
                />
              </Fragment>
            )}
          </div>
        </div>
        <DownloadDropdown
          fullWidth={true}
          eventSgId={eventSgId}
          values={availableZips}
          downloadType="zip"
        />
      </div>
    );
  }
}

AccountPhotoDownload.propTypes = {
  eventSgId: PropTypes.number,
  availableZips: PropTypes.array,
};

export default AccountPhotoDownload;
